module.exports = __webpack_public_path__ + "static/media/doc.bc5f9db1.svg";